<template>
  <div class="footer">
    <div class="text-center" style="color: #fff;">
      <div>Maior serviço com validade jurídica de entrega de documentos eletrônicos do Brasil</div>
      <div style="font-size: 0.85em; margin-top: 5px; opacity: 0.9;">As datas e horas apresentadas seguem o fuso horário de Brasília</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppFooter'
}
</script>
<style scoped>
  .footer {
    background-color: #0a437c;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 60px;
    padding: 10px 0;
    z-index: 10;
    display: flex;
    align-content: center;
    vertical-align: middle;
    align-items: center;
  }
  .footer div{ width: 100%}
  .footer a{ color:#fac812;}
</style>



// WEBPACK FOOTER //
// src/components/root/AppFooter.vue